import { Transitions } from "@components";
import VideoPlayer from "@components/VideoPlayer";
import { useAppSelector } from "@app/hooks";
import { getInstructionFromStep } from "@helpers/instructionHelper";
import { NavItems } from "@helpers/navigation";
import { sleepFor } from "@helpers/countHelper";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import { AssessmentShell } from "../components/AssessmentShell";

export const AssessmentDeviceCheckInstruction = (): JSX.Element => {
    const [errorLoadingVideo, setErrorLoadingVideo] = useState(false);
    const [currentCaption, setCurrentCaption] = useState("");

    const navigate = useNavigate();

    const practiceInstruction = useAppSelector((x) =>
        getInstructionFromStep(x.assessmentForm.instructions, "Practice")
    );

    const handleOnEnd = async (): Promise<void> => {
        await sleepFor(2);

        navigate(NavItems.Assessments.AssessmentChecks.path);
    };

    useEffect(() => {
        if (errorLoadingVideo) {
            const instructions = practiceInstruction.instructionText.split(";");

            instructions.forEach((instruction, index) => {
                setTimeout(() => {
                    setCurrentCaption(instruction);
                }, index * 3 * 1000);
            });

            setTimeout(() => {
                void handleOnEnd();
            }, (instructions.length + 1) * 3 * 1000);
        }
    }, [practiceInstruction, errorLoadingVideo]);

    const handleOnVideoError = (): void => {
        setErrorLoadingVideo(true);
    };

    return (
        <AssessmentShell micVolume={0} micIsRecording={false}>
            {errorLoadingVideo && (
                <div className="columns">
                    <div className="column">
                        <Transitions currentCaption={currentCaption} />
                    </div>
                </div>
            )}
            {!errorLoadingVideo && (
                <VideoPlayer
                    url={practiceInstruction.instructionVideoUrl}
                    onLoadError={handleOnVideoError}
                    onEnd={handleOnEnd}
                />
            )}
        </AssessmentShell>
    );
};
